import { AnalyticsService } from "./analytics-service";

export enum ProductEvent {
  // Scheduler
  ScheduleMessage = "schedule_message",
  CancelScheduledMessage = "cancel_scheduled_message",
  UpdateScheduledMessage = "update_scheduled_message",
  SendMessage = "send_message",
  OpenScheduleDialog = "open_schedule_dialog",
  ViewMessageStatus = "view_message_status",
  EditMessage = "edit_message",
  RemoveMessage = "remove_message",

  // Campaigns
  CreateCampaign = "create_campaign",
  LaunchCampaign = "launch_campaign",
  CancelCampaign = "cancel_campaign",
  CancelSubscription = "cancel_subscription",
  // BE#498 cancel-flow funnel (client-side; the server records cancels/saves durably, but
  // only the client sees the flow being OPENED and DISMISSED/kept — the abandonment leg).
  CancelFlowOpened = "cancel_flow_opened",
  CancelFlowOfferShown = "cancel_flow_offer_shown",
  CancelFlowSaved = "cancel_flow_saved",
  CancelFlowDismissed = "cancel_flow_dismissed",
  UpdateCampaign = "update_campaign",
  CreateTemplate = "create_template",
  UseTemplate = "use_template",

  // Tasks
  CreateTask = "create_task",
  CompleteTask = "complete_task",
  UpdateTask = "update_task",
  CreateBoard = "create_new_board",
  CreateTaskGroup = "create_new_group",

  // Feature First Use
  FirstScheduleCreated = "first_schedule_created",
  FirstCampaignCreated = "first_campaign_created",
  FirstTaskCreated = "first_task_created",

  // User Engagement
  LoginSuccess = "login_success",
  LoginFailed = "login_failed",
  UserOnboarding = "user_onboarding",
  FeatureDiscovery = "feature_discovery",

  // Chrome Extension
  ExtensionInstall = "install_extension",
  ExtensionUpdate = "update_extension",
  ExtensionUninstall = "uninstall_extension",
}

const analyticsService = new AnalyticsService();

export const trackProductEvent = (event: ProductEvent, properties: Record<string, any> = {}) => {
  analyticsService.event(event, {
    category: "product_engagement",
    ...properties,
  });
};

// Track feature first use with specific properties
export const trackFeatureFirstUse = (feature: string, properties: Record<string, any> = {}) => {
  analyticsService.event(`first_${feature}_created`, {
    category: "feature_adoption",
    action: "first_use",
    feature_name: feature,
    ...properties,
  });
};

// Track time to first value
export const trackTimeToFirstValue = (action: string, timeToValue: number, properties: Record<string, any> = {}) => {
  analyticsService.event("time_to_first_value", {
    category: "user_journey",
    action: action,
    value: timeToValue,
    time_to_value_seconds: timeToValue,
    ...properties,
  });
}; 